export const ADD_RAM_ER = 'ADD_RAM_ER';